import React from 'react'
import {
  Box,
  Button,
  Typography
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import { LoadingSpinner } from '../atoms'
import TemplateCard from './TemplateCard'
import styles from '../../views/settings/SettingsNotifications.module.scss'

const TemplatesTab = ({
  templates,
  loading,
  onCreateNew,
  onEdit,
  onDelete,
  onPreview,
  onDuplicate
}) => {
  if (loading) {
    return (
      <LoadingSpinner />
    )
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h6">Email Templates</Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<FontAwesomeIcon icon={faFileAlt} />}
          onClick={onCreateNew}
        >
          Create Template
        </Button>
      </Box>

      {templates.length === 0 ? (
        <Box textAlign="center" p={4}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No templates created
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            Create email templates to customize the content of your automated notifications.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FontAwesomeIcon icon={faFileAlt} />}
            onClick={onCreateNew}
          >
            Create First Template
          </Button>
        </Box>
      ) : (
        <div className={styles.templatesGrid}>
          {templates.map(template => (
            <TemplateCard
              key={template.id}
              template={template}
              onEdit={onEdit}
              onDelete={onDelete}
              onPreview={onPreview}
              onDuplicate={onDuplicate}
              className={styles.templateCard}
            />
          ))}
        </div>
      )}
    </Box>
  )
}

TemplatesTab.propTypes = {
  templates: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onCreateNew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired
}

export default TemplatesTab